import { Controller } from '@hotwired/stimulus'
import { post } from '../lib/request'

const BASE_URL = '.darkroom.com'

export default class extends Controller {
  static targets = ['username', 'placeholder', 'password']
  static values = { url: String }

  usernameTargetConnected = (target) => {
    if (target.value) this.updatePlaceholders(target.value)

    target.addEventListener('input', e => this.checkUsername(e))
  }

  updatePlaceholder = (event) => {
    const newValue = event.target.value

    return this.updatePlaceholders(`${newValue}${BASE_URL}`)
  }

  async checkUsername(event) {
    if (event.target.value.length === 0) {
      this.updatePlaceholders('Url')
      this.updateErrors()
    }
    else {
      const params = { username: event.target.value }
      const response = await post(this.urlValue, { responseKind: 'json', body: JSON.stringify(params) })

      if (response.ok) {
        const json = await response.json
        if (json.username === undefined) {
          this.updateErrors()
        }
        else {
          this.updateErrors('2px solid red', json.username.join(', '))
        }
      }
    }
  }

  checkPassword = () => {
    if (this.passwordRegex.test(this.passwordTarget.value)) {
      this.passwordErrorDiv.innerHTML = ''
    }
    else {
      this.passwordErrorDiv.innerHTML = this.passwordMessage
    }
  }

  updateErrors = (border = '', html = '') => {
    this.usernameTarget.border = border
    this.usernameErrorDiv.innerHTML = html
  }

  updatePlaceholders = (value) => {
    this.placeholderTarget.placeholder = value
    this.usernameTarget.placeholder = value
    this.placeholderTarget.value = value
  }

  get usernameErrorDiv() {
    return document.querySelector('[data-error-text="username"]')
  }

  get passwordErrorDiv() {
    return document.querySelector('[data-error-text="password"]')
  }

  get passwordRegex() {
    return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
  }

  get passwordMessage() {
    return 'must contain one letter, one number, and one symbol, and 8 or more characters'
  }
}
